import { css } from 'styled-components';
import { s16 } from '@ardoq/design-tokens';
import { ToastPosition } from './types';

const TOAST_HEIGHT_PLUS_GAP = 82;

const getFadeOutTop = () => `
  from {
    top: 0;
    opacity: 1;
  }
  to {
    top: -${s16};
    opacity: 0;
  }
`;

const getFadeOutBottom = () => `
  from {
    bottom: 0;
    opacity: 1;
  }
  to {
    bottom: -${s16};
    opacity: 0;
  }
`;

const getSlideDown = () => `
  from {
    top: -${TOAST_HEIGHT_PLUS_GAP}px;
  }
  to {
    top: 0;
  }
`;

const getSlideUp = () => `
  from {
    top: ${TOAST_HEIGHT_PLUS_GAP}px;
  }
  to {
    top: 0;
  }
`;

const getSlideUpFromBottom = () => `
  from {
    bottom: -${TOAST_HEIGHT_PLUS_GAP}px;
  }
  to {
    bottom: 0;
  }
`;

const getSlideDownFromBottom = () => `
  from {
    bottom: ${TOAST_HEIGHT_PLUS_GAP}px;
  }
  to {
    bottom: 0;
  }
`;

const getSlideOut = () => `
  from {
    top: -${TOAST_HEIGHT_PLUS_GAP}px;
    opacity: 1;
  }
  to {
    top: ${TOAST_HEIGHT_PLUS_GAP / 2}px;
    opacity: 0;
  }
`;

const getSlideOutBottom = () => `
  from {
    bottom: -${TOAST_HEIGHT_PLUS_GAP}px;
    opacity: 1;
  }
  to {
    bottom: ${TOAST_HEIGHT_PLUS_GAP / 2}px;
    opacity: 0;
  }
`;

export const getKeyframes = () => css`
  @keyframes slideDown1 {
    ${getSlideDown()}
  }
  @keyframes slideDown2 {
    ${getSlideDown()}
  }
  @keyframes slideIn {
    ${getSlideDown()}
  }
  @keyframes slideOut {
    ${getSlideOut()}
  }
  @keyframes fadeOut {
    ${getFadeOutTop()}
  }
  @keyframes slideUp0 {
    ${getSlideUp()}
  }
  @keyframes slideUp1 {
    ${getSlideUp()}
  }
  @keyframes slideUpFromBottom1 {
    ${getSlideUpFromBottom()}
  }
  @keyframes slideUpFromBottom2 {
    ${getSlideUpFromBottom()}
  }
  @keyframes slideInFromBottom {
    ${getSlideUpFromBottom()}
  }
  @keyframes slideOutBottom {
    ${getSlideOutBottom()}
  }
  @keyframes fadeOutBottom {
    ${getFadeOutBottom()}
  }
  @keyframes slideDownFromBottom0 {
    ${getSlideDownFromBottom()}
  }
  @keyframes slideDownFromBottom1 {
    ${getSlideDownFromBottom()}
  }
`;

export const TOAST_DURATION = 5000;

const ANIMATION_START_DURATION = 500;
export const ANIMATION_END_DURATION = 400;

export const getAnimationCSS = ({
  index,
  shouldMoveUp,
  animate,
  position,
}: {
  index: number;
  shouldMoveUp: boolean;
  animate?: boolean;
  position: ToastPosition;
}) => {
  let animationName = '';
  let fadeOutAnimation = '';

  if (animate === false) return '';

  const isBottom = position === ToastPosition.BOTTOM_RIGHT;

  if (isBottom) {
    fadeOutAnimation = 'fadeOutBottom';
    if (shouldMoveUp) {
      animationName = `slideDownFromBottom${index}`;
    } else if (index === 0) {
      animationName = 'slideInFromBottom';
    } else if (index <= 2) {
      animationName = `slideUpFromBottom${index}`;
    } else {
      animationName = 'slideOutBottom';
    }
  } else {
    fadeOutAnimation = 'fadeOut';
    if (shouldMoveUp) {
      animationName = `slideUp${index}`;
    } else if (index === 0) {
      animationName = 'slideIn';
    } else if (index <= 2) {
      animationName = `slideDown${index}`;
    } else {
      animationName = 'slideOut';
    }
  }

  return css`
    animation:
      ${ANIMATION_START_DURATION}ms ${animationName},
      ${ANIMATION_END_DURATION}ms ${fadeOutAnimation}
        ${TOAST_DURATION - ANIMATION_END_DURATION}ms;
  `;
};
